import { bl_svc_doc_hdr_RowClass } from '../../../dbschema/bl_svc_doc_hdr.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceDocHdrContainerModel extends BaseContainerModel {
  bl_svc_doc_hdr: bl_svc_doc_hdr_RowClass = new bl_svc_doc_hdr_RowClass();
}
